export default function HeartOutlineIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M8 13.5C7.5 13.5 2 10 2 5.75C2 3.95507 3.45507 2.5 5.25 2.5C6.40788 2.5 7.42434 3.10551 8 4.01716C8.57566 3.10551 9.59212 2.5 10.75 2.5C12.5449 2.5 14 3.95507 14 5.75C14 10 8.5 13.5 8 13.5Z'
        strokeWidth='1.375'
        strokeLinejoin='round'
      />
    </>
  );
}
